<template>
<div class="login">
  <div class="main-inner">
    <main>
      <!-- .radius-box.white-box.row -->
      <section v-if="!mailSent" class="radius-box white-box row">
        <h2 class="login-pagetitle">パスワード再設定</h2>
        <form action="/">
          <ul class="login-form">
            <li>
              <input type="text" name="email" v-model="email" placeholder="メールアドレス">
              <div v-if="submitted && !$v.email.required" class="text-error util-line-height-none"><small>メールアドレスを入力してください。</small></div>
              <div v-if="submitted && $v.email.required && !$v.email.email" class="text-error util-line-height-none"><small>マールアドレスのフォーマットに誤りがあります。</small></div>
            </li>
            <li v-if="displayErrorMessage" class="text-error"><small>{{ errorMessage }}</small></li>
            <li class="btn-gray2"><button @click.prevent="sendBtnClick">送信する</button></li>
          </ul>
        </form>
      </section>
      <section v-if="mailSent" class="radius-box white-box row">
        <h2 class="login-pagetitle">送信が完了しました</h2>
        <p class="text-center">入力されたメールアドレスにパスワード再設定用のURLを記載したメールを送信しました。</p>
        <p class="text-center">有効期限内にパスワードの再設定を行って下さい。</p>
        <br>
        <div class = "btn-set">
          <a href="corp_admin/login" class="btn-gray2"><button>ログインへ戻る</button></a>
        </div>
      </section>
    </main>
  </div>
</div>
</template>

<script>
import httpResource from '../../http/httpResource'
import { required, email } from 'vuelidate/lib/validators'
import { parseApierror } from '../../util/utils'
export default {
  name: 'ResetPassword',
  data () {
    return {
      email: '',
      submitted: false,
      displayErrorMessage: false,
      errorMessage: '',
      mailSent: false
    }
  },
  beforeCreate: function () {
    document.body.className = 'login'
  },
  beforeDestroy: function () {
    document.body.classList.remove('login')
  },
  validations: {
    email: {
      email,
      required
    }
  },
  methods: {
    async sendBtnClick () {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      try {
        const response = await httpResource.post('/corporation/reset-password', this.email)
        if (response.status === 200) {
          this.mailSent = true
        }
      } catch (error) {
        const apierror = parseApierror(error)
        this.displayErrorMessage = true
        this.errorMessage = apierror.message
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reset-password/index.vue